/* eslint-disable class-methods-use-this */
export default class CollapsedChildrenRule {
  isSupport(filters, node) {
    if (node.data.attributes?.referred?.length && !node.data.children.length) {
      return true;
    }
    return false;
  }
  getTextColor() {
    return '#FFFFFF';
  }
  getNodeBackgroundColor() {
    return '#411F90';
  }
}
